/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserSecurityClearanceUpdateRequest
 */
export interface UserSecurityClearanceUpdateRequest {
    /**
     * 
     * @type {number}
     * @memberof UserSecurityClearanceUpdateRequest
     */
    maxSecurityLevel?: number;
    /**
     * 
     * @type {Date}
     * @memberof UserSecurityClearanceUpdateRequest
     */
    expiresAt?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof UserSecurityClearanceUpdateRequest
     */
    isActive?: boolean;
}

/**
 * Check if a given object implements the UserSecurityClearanceUpdateRequest interface.
 */
export function instanceOfUserSecurityClearanceUpdateRequest(value: object): value is UserSecurityClearanceUpdateRequest {
    return true;
}

export function UserSecurityClearanceUpdateRequestFromJSON(json: any): UserSecurityClearanceUpdateRequest {
    return UserSecurityClearanceUpdateRequestFromJSONTyped(json, false);
}

export function UserSecurityClearanceUpdateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserSecurityClearanceUpdateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'maxSecurityLevel': json['maxSecurityLevel'] == null ? undefined : json['maxSecurityLevel'],
        'expiresAt': json['expiresAt'] == null ? undefined : (new Date(json['expiresAt'])),
        'isActive': json['isActive'] == null ? undefined : json['isActive'],
    };
}

export function UserSecurityClearanceUpdateRequestToJSON(json: any): UserSecurityClearanceUpdateRequest {
    return UserSecurityClearanceUpdateRequestToJSONTyped(json, false);
}

export function UserSecurityClearanceUpdateRequestToJSONTyped(value?: UserSecurityClearanceUpdateRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'maxSecurityLevel': value['maxSecurityLevel'],
        'expiresAt': value['expiresAt'] == null ? undefined : ((value['expiresAt']).toISOString()),
        'isActive': value['isActive'],
    };
}

